import script from "./live-input-bubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./live-input-bubble.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__